import React, { memo } from "react";
import { Link } from "react-router-dom";
import type { DiscoverPageItemDetail } from "@highnote/server/src/functions/handlers/discover/types";
import { getSpaceUrl } from "../shared";
import { Byline } from "../Byline";
import "./styles.scss";

export const MiniSpaceTile = memo(
  ({ itemDetail }: { itemDetail: DiscoverPageItemDetail | null }) => {
    const url = itemDetail?.entityId
      ? getSpaceUrl(itemDetail.entityId, itemDetail.shareKey)
      : null;

    const content = (
      <div className="mini-space-tile">
        <div className="mini-space-tile-artwork">
          {itemDetail?.squareImageUrl && (
            <img
              src={itemDetail.squareImageUrl}
              alt={itemDetail?.title ?? ""}
            />
          )}
        </div>
        <div className="mini-space-tile-info">
          {itemDetail?.title && (
            <span className="mini-space-tile-name">{itemDetail.title}</span>
          )}
          {itemDetail?.createdByName && (
            <Byline
              picture={itemDetail.createdByPicture}
              name={itemDetail.createdByName}
            />
          )}
        </div>
      </div>
    );

    if (url) {
      return <Link to={url}>{content}</Link>;
    }

    return content;
  },
);
MiniSpaceTile.displayName = "MiniSpaceTile";
